const answerRoute = {
	name: 'answers',
	path: 'answers',
	meta: {
		title: 'Respuestas',
	},
	redirect: 'answers/list',
	component: () => import('@/pages/configuration/page-answer'),
	children: [
		{
			name: 'list',
			path: 'list',
			meta: {
				title: 'Listado de respuestas',
			},
			components: {
				answerList: () => import('@/components/configuration/answer/answer-list'),
			},
			children: [
				{
					name: 'new-answer',
					path: 'new',
					meta: {
						title: 'Nueva respuesta',
					},
					components: {
						answerNew: () => import('@/components/configuration/answer/answer-new'),
					},
					children: [
						{
							name: 'answer-icon',
							path: 'answer-icon/:index/:type',
							components: {
								modalAnswerIcon: () => import('@/components/shared/icons/icon-modal'),
							},
						},
					],
				},
				{
					name: 'edit-answer',
					path: 'edit/:id',
					meta: {
						title: 'Edición de respuesta',
					},
					components: {
						answerEdit: () => import('@/components/configuration/answer/answer-new'),
					},
					children: [
						{
							name: 'answer-icon',
							path: 'answer-icon/:index/:type',
							components: {
								modalAnswerIcon: () => import('@/components/shared/icons/icon-modal'),
							},
						},
					],
				},
			],
		},
	],
};

export default answerRoute;



// WEBPACK FOOTER //
// ./src/router/configuration/answers/index.js